import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomSalespersonActionInterface, Status } from '@vendasta/sales-orders';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { TranslateService } from '@ngx-translate/core';

export interface OrderConfirmationActionConfig {
  allowSendDirectToAdmin?: boolean;
  allowSendToCustomer?: boolean;
  leaseToAutomations?: boolean;
  customSalespersonActions?: CustomSalespersonActionInterface[];
}

interface buttonInterface {
  label: string;
  id: string;
  dataAction: string;
  action: () => void;
}

@Component({
  selector: 'orders-actions',
  templateUrl: './order-actions.component.html',
  styleUrls: ['./order-actions.component.scss'],
})
export class OrderActionsComponent implements OnInit {
  @Input() submitDisabled = true;
  @Input() config: OrderConfirmationActionConfig;
  // the order of the status determines the action buttons where null is used for a brand new order
  @Input() orderStatus: Status = null;

  @Output() goBackEmitter: EventEmitter<null> = new EventEmitter<null>();
  @Output() createDraftEmitter: EventEmitter<null> = new EventEmitter<null>();
  @Output() submitOrderEmitter: EventEmitter<null> = new EventEmitter<null>();
  @Output() submitForCustomerApprovalEmitter: EventEmitter<null> = new EventEmitter<null>();
  @Output() leaseOrderToAutomationsEmitter: EventEmitter<null> = new EventEmitter<null>();
  @Output() submitForAutomationActionEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() convertToDraftEmitter = new EventEmitter<null>();
  @Output() requestCancellationEmitter = new EventEmitter<null>();

  draftActionButtons: buttonInterface[] = [];

  status = Status;

  constructor(
    private readonly snowplowService: ProductAnalyticsService,
    private readonly translate: TranslateService,
  ) {}

  ngOnInit(): void {
    if (this.config.allowSendDirectToAdmin) {
      this.draftActionButtons.push({
        action: this.submitOrder.bind(this),
        dataAction: 'order-confirm-submit',
        id: 'order-confirm-submit-c1',
        label: this.translate.instant('COMMON.ORDERS.SUBMIT_ORDER'),
      });
    }
    if (this.config.allowSendToCustomer) {
      this.draftActionButtons.push({
        action: this.submitForCustomerApproval.bind(this),
        dataAction: 'order-confirm-submit-customer',
        id: 'order-confirm-submit-customer-c1',
        label: this.translate.instant('COMMON.ORDERS.SUBMIT_FOR_CUSTOMER_APPROVAL'),
      });
    }
    this.config?.customSalespersonActions?.map((a) => {
      this.draftActionButtons.push({
        action: this.submitForAutomationAction(a.automationId).bind(this),
        dataAction: 'order-confirm-submit-' + a.automationId,
        id: 'order-confirm-submit-' + a.automationId,
        label: a.label,
      });
    });
  }

  goBack(): void {
    this.goBackEmitter.emit();
  }

  createDraftOrder(): void {
    this.createDraftEmitter.emit();
  }

  submitOrder(): void {
    this.submitOrderEmitter.emit();
  }

  submitForCustomerApproval(): void {
    this.submitForCustomerApprovalEmitter.emit();
  }

  submitForAutomationAction(automationId: string): () => void {
    return () => {
      this.submitForAutomationActionEmitter.emit(automationId);
    };
  }

  leaseOrderToAutomations(): void {
    this.leaseOrderToAutomationsEmitter.emit();
  }

  onConvertToDraft(): void {
    this.convertToDraftEmitter.emit();
  }

  onIntentToCancel(): void {
    this.requestCancellationEmitter.emit();
  }
}
